module.exports = __webpack_public_path__ + "img/bv.802a2a67.svg";